import { useMemo } from 'react'

import { RelatedRecordWidgetType } from 'features/views/LayoutEditor/widgets/RelatedRecordWidget/types'
import { useRecordManagerContext } from 'features/views/RecordManager/useRecordManagerContext'

import { useRelatedRecordWidgetTarget } from './useRelatedRecordWidgetTarget'

export function useRelatedRecordWidgetWrapperState(widget: RelatedRecordWidgetType) {
    const { targetFieldApiName } = useRelatedRecordWidgetTarget(widget)
    const { record: localRecord, showSuccessToast } = useRecordManagerContext()
    const targetFieldValue = localRecord?.[targetFieldApiName!]
    const targetRecordSid = getTargetRecordSid(targetFieldValue)

    return useMemo(
        () => ({
            targetRecordSid,
            showSuccessToast,
        }),
        [targetRecordSid, showSuccessToast]
    )
}

function getTargetRecordSid(value?: string | string[]) {
    if (!value) return undefined

    if (Array.isArray(value)) {
        return [...value].sort((a, b) => a.localeCompare(b))[0]
    }

    return value
}
